import { BusinessInsightsContextValue } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/businessInsightsContext';

export enum InsightsErrorStateVariant {
  WITH_REFRESH_ACTION = 'WITH_REFRESH_ACTION',
  WITHOUT_REFRESH_ACTION = 'WITHOUT_REFRESH_ACTION',
}
export type InsightsErrorStateCopy = {
  title: string;
  description: string;
  refreshActionLabel?: string;
};

export type InsightsErrorStateVariantParams = Pick<
  BusinessInsightsContextValue,
  'enabled' | 'isError' | 'isLoading'
>;

export const BUSINESS_ADMIN_INSIGHTS_ERROR_STATE_COPY: Record<
  InsightsErrorStateVariant,
  InsightsErrorStateCopy
> = {
  [InsightsErrorStateVariant.WITH_REFRESH_ACTION]: {
    title: 'Unable to load insights',
    description:
      "We're having trouble connecting right now. If refreshing doesn't work, try again later.",
    refreshActionLabel: 'Refresh page',
  },
  [InsightsErrorStateVariant.WITHOUT_REFRESH_ACTION]: {
    title: 'Unable to load insights',
    description: 'Please try again later',
  },
} as const;

export function getBusinessAdminInsightsErrorStateCopy(
  variant: InsightsErrorStateVariant
): InsightsErrorStateCopy {
  return BUSINESS_ADMIN_INSIGHTS_ERROR_STATE_COPY[variant];
}

export function getInsightsErrorStateVariant({
  enabled,
  isError,
  isLoading,
}: InsightsErrorStateVariantParams): InsightsErrorStateVariant | null {
  if (isLoading) {
    return null;
  }

  if (!enabled) {
    return InsightsErrorStateVariant.WITHOUT_REFRESH_ACTION;
  }

  if (isError) {
    return InsightsErrorStateVariant.WITH_REFRESH_ACTION;
  }

  return null;
}
